export interface ClipboardContent {
	/** Plain text, used by plain inputs and as the fallback everywhere. */
	text: string
	/** Optional HTML flavour, kept by rich editors such as Slack or Gmail. */
	html?: string
}

/**
 * Copies content to the clipboard with the async Clipboard API. When `html`
 * is provided both flavours are written so that rich editors keep links and
 * formatting while plain inputs get the text version.
 *
 * Requires a secure context (https or localhost) and a user gesture, and
 * rejects when the browser refuses the write.
 */
export const copyToClipboard = async ({
	text,
	html
}: ClipboardContent): Promise<void> => {
	if (!navigator.clipboard) {
		throw new Error('Clipboard API is not available')
	}

	if (html) {
		await navigator.clipboard.write([
			new ClipboardItem({
				'text/plain': new Blob([text], { type: 'text/plain' }),
				'text/html': new Blob([html], { type: 'text/html' })
			})
		])
	} else {
		await navigator.clipboard.writeText(text)
	}
}
